export const SPIDER_LEG_COLOR = '#4b5563';
export const SPIDER_ANCHOR_STROKE = '#22c55e';
export const SPIDER_ANCHOR_FILL = '#86efac';

export const SPIDER_DEFAULT_RADIUS_METERS = 24;
export const SPIDER_ARC_START_RAD = Math.PI / 4;
export const SPIDER_ARC_END_RAD = (3 * Math.PI) / 4;

const SPIDER_GROUP_DECIMALS = 6;

export function roundCoordForSpiderGroup(coordinateInDegrees: number): number {
  const factor = 10 ** SPIDER_GROUP_DECIMALS;
  return Math.round(coordinateInDegrees * factor) / factor;
}

const EARTH_METERS_PER_DEG_LAT = 111_320;

export { EARTH_METERS_PER_DEG_LAT };
